// Import packages
import React, { Component } from "react";
import { connect } from "react-redux";
import swal from "sweetalert";

//import styles
import '../../assets/styles/containerStyles/about.scss';

// Import components
import PageWrapper from '../../components/pageContentViews/pageWrapper'
import MediaSelectorModal from "../../components/media/MediaSelectorModal";
import { InputGroup } from "../../components/uiElements/inputGroup";
import { LinkButton } from "../../components/buttons/buttons";
import { LanguageTabs } from "../../components/uiElements/Tabs";
import { MediaFileCard } from "../../components/media/MediaFileCard";

// Import utils
import {
    changeStateField,
    getInputValues,
    getPatchReqData,
    getTranslatableInputValues,
    getTranslationData,
    initTranslations,
} from "../../utils/helperFunctions";
import { mapStateToProps } from "../../redux/mapStateToProps";
import { UpdateAboutData } from "../../redux/actions";
import { validateTranslations } from "../../utils/validateTranslations";
import { ACCEPT_IMAGE_TYPES } from "../../constants/acceptedTypes";
import { history } from "../../configs/history";
import { Editor } from "../../components/uiElements/Editor";


class AddEditAboutBlock extends Component {
    constructor (props) {
        super(props);
        this.translationsFields = [
            'title',
            'description'
        ];
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields, props.activeLanguages),
                mediaMain: undefined,
            },
            errors: {},
            errorsTabs: [],
            isEditing: !!props?.id,
            languageTab: props.mainLanguage,
            requestLoading: false,
            mediaModalType: '',
        };
        this.updatedDataMap = new Map();
        this.currentData = null;
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.getInputValues = getInputValues.bind(this);
        this.getPatchReqData = getPatchReqData.bind(this);
        this.getTranslationValues = getTranslatableInputValues.bind(this);
        this.getMedia = this.getMedia.bind(this);
        this.deleteMedia = this.deleteMedia.bind(this);
        this.addEditAboutBlock = this.addEditAboutBlock.bind(this);
    }

    async componentDidMount () {
        const { id, aboutData } = this.props;
        const { isEditing, fieldsData } = this.state;
        if (isEditing && !id) {
            history.push('/about');
            return;
        }

        if (isEditing) {
            const editingData = aboutData?.blocks?.[id];
            const translationsData = {};

            Object.keys(fieldsData.translations).forEach(key => {
                const trItem = editingData?.translations?.find(item => item.languageId === key);
                translationsData[key] = {
                    ...fieldsData.translations[key],
                    title: trItem?.title || '',
                    description: trItem?.description || '',
                };
            });
            const initStateData = {
                translations: translationsData,
                mediaMain: editingData?.mediaMain || '',
            };
            this.currentData = JSON.parse(JSON.stringify(initStateData));
            this.setState({
                fieldsData: initStateData,
            });
        }
    }

    getMedia (type, mediaArray) {
        const { fieldsData, errors, isEditing } = this.state;
        if (isEditing) {
            this.currentData?.mediaMain?.id !== mediaArray[0]?.id
                ? this.updatedDataMap.set(type, mediaArray[0]?.id)
                : this.updatedDataMap.delete(type);
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                [type]: mediaArray[0],
            },
            errors: {
                ...errors,
                [type]: false
            }
        })
    }

    deleteMedia () {
        const { fieldsData, isEditing, mediaModalType } = this.state;
        if (isEditing) {
            this.currentData?.mediaMain ?
                this.updatedDataMap.set(mediaModalType, null) :
                this.updatedDataMap.delete(mediaModalType);
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                [mediaModalType]: null
            }
        })
    }

    toggleMediaModalType (type = '') {
        this.setState({
            mediaModalType: type
        })
    }

    async addEditAboutBlock () {
        await this.setState({
            requestLoading: true
        });
        console.log('addEditAboutBlock');
        const { aboutData } = this.props;
        const { translations, mediaMain} = this.state.fieldsData;
        const translationRequiredFields = ['title', 'description'];
        const validationTr = validateTranslations(translations, translationRequiredFields);
        let result = validationTr.result;
        const errors = { ...validationTr.errors };
        if (!mediaMain) {
            errors.mediaMain = true;
            result = false;
        }

        if (result) {
            if (!this.state.isEditing) {
                let updatedBlock = {
                    translations: getTranslationData(translations),
                    mediaMain: mediaMain?.id || '',
                }
                const reqData = {
                    blocks: [updatedBlock, ...aboutData.blocks.map(block => {
                        return {
                            ...block,
                            mediaMain: block?.mediaMain?.id || null,
                        }
                    })]
                }
                this.props.UpdateAboutData(reqData).finally(() => {
                    this.setState({ requestLoading: false });
                    history.push(`/about`)
                })
            } else {
                const { id } = this.props;
                const trData = getTranslationData(translations);
                const newBlock = {
                    translations: trData,
                    mediaMain: mediaMain?.id || null,
                }
                const reqData = {
                    blocks: aboutData.blocks.map((block, index) => {
                        if (index === +id) {
                            return newBlock
                        }
                        return {
                            ...block,
                            mediaMain: block?.mediaMain?.id || null,
                        }
                    })
                }
                this.props.UpdateAboutData(reqData).finally(() => {
                    this.setState({ requestLoading: false });
                    history.push(`/about`)
                })
            }
        } else {
            this.setState({
                requestLoading: false,
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }
    }

    render () {
        const { fieldsData, errors, languageTab, mediaModalType, requestLoading, isEditing, errorsTabs } = this.state;
        const initData = this.currentData?.translations[languageTab] || {};
        const currentData = fieldsData.translations[languageTab] || {};

        return <PageWrapper pageTitle={!isEditing ? 'Ավելացնել Ծառայություն' : 'Փոփոխել Ծառայություն'}>
            <section className="slider-add-edit">

                <div className="top-side">
                    <label>Նկար<span className={'required-badge'}>*</span></label>
                    <LinkButton title="Ընտրել մեդիադարանից"
                                className={`media-select-btn ${errors.mediaMain ? 'media-select-error' : ''}`}
                                cb={this.toggleMediaModalType.bind(this, 'mediaMain')}
                    />
                </div>
                {fieldsData?.mediaMain && <div className={'main-media'}>
                    <MediaFileCard item={fieldsData?.mediaMain}
                                   customDelete={this.deleteMedia}
                    />
                </div>}

                <div className="info-wrapper">
                    <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                                  errorsTabs={errorsTabs}
                                  activeTab={languageTab}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="Անուն"
                                placeholder="Անուն"
                                name="title"
                                value={currentData.title}
                                initValue={initData.title}
                                error={errors['title' + languageTab]}
                                maxLength={100}
                                required={true}
                                onChange={this.getTranslationValues}/>
                    <InputGroup inputType="textarea"
                                type="text"
                                label="Քարտի նկարագրությունը"
                                placeholder="Քարտի նկարագրությունը"
                                name="description"
                                value={currentData.description}
                                initValue={initData.description}
                                error={errors['description' + languageTab]}
                                maxLength={1000}
                                required={true}
                                onChange={this.getTranslationValues}/>
                </div>
                <div className="flex-wrapper-right">
                    <LinkButton title={!isEditing ? 'Ավելացնել' : 'Փոփոխել'}
                                loading={requestLoading}
                                disabled={isEditing && !this.updatedDataMap.size}
                                cb={this.addEditAboutBlock}/>
                </div>
            </section>
            <MediaSelectorModal
                isOpen={!!mediaModalType}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                getMedia={this.getMedia.bind(this, mediaModalType)}
                closeModal={this.toggleMediaModalType.bind(this)}
            />
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    UpdateAboutData
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEditAboutBlock)
